var map = {
	"./Antibody-2.jpg": 508,
	"./antibodies.jpg": 509,
	"./antivirals.jpg": 510,
	"./cell-based-therapies.jpg": 511,
	"./device.jpg": 512,
	"./dna-based.jpg": 513,
	"./inactivated-virus.jpg": 514,
	"./live-attenuated-virus.jpg": 515,
	"./non-replicating-viral-vector.jpg": 516,
	"./other.jpg": 41,
	"./protein-subunit.jpg": 517,
	"./replicating-bacterial-vector.jpg": 518,
	"./replicating-viral-vector.jpg": 519,
	"./rna-based-treatments.jpg": 520,
	"./rna-based-vaccine.jpg": 521,
	"./scanning-compounds-to-repurpose.jpg": 522,
	"./virus-like-particle.jpg": 523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;